import React from 'react';
import { css } from 'glamor';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import * as theme from '../theme';
import { Label } from './Label';
import { inputSize } from './Input';

export const PhoneNumberInput = ({
	label,
	error,
	size = 'medium',
	value,
	onValueChange,
	defaultCountry,
	className,
	...props
}) => {
	const CSS = inputSize[size];
	const errorStyle = !!error && {
		color: theme.flavours.danger.foregroundColor,
		borderColor: theme.flavours.danger.highlightColor,
	};

	return <div className={className}>
		{label && <Label error={error}>{label}</Label>}
		<PhoneInput
			international
			countryCallingCodeEditable={false}
			defaultCountry={defaultCountry}
			value={value || undefined}
			onChange={(next) => onValueChange(next ?? '')}
			className={css(
				{
					display: 'flex',
					alignItems: 'center',
					gap: 8,
					width: '100%',
					boxSizing: 'border-box',
					background: theme.white,
					borderWidth: CSS.borderWidth,
					borderStyle: 'solid',
					borderColor: theme.gray10,
					borderRadius: CSS.borderRadius,
					height: CSS.height,
					paddingLeft: CSS.paddingLeft,
					paddingRight: CSS.paddingRight,
					marginBottom: CSS.marginBottom,
					transition: theme.transitionSnappy,
					':focus-within': {
						borderColor: theme.blue,
					},
					' .PhoneInputInput': {
						flex: 1,
						minWidth: 0,
						border: 'none',
						outline: 'none',
						background: 'transparent',
						fontSize: CSS.fontSize,
						fontFamily: 'inherit',
						color: 'inherit',
					},
					' .PhoneInputInput::placeholder': {
						color: theme.gray20,
					},
					' .PhoneInputCountrySelectArrow': {
						opacity: 1,
					},
				},
				errorStyle,
			)}
			{...props}
		/>
	</div>
};
